import React from "react";
import { FaEnvelope } from "react-icons/fa";
import "./contact.css";

export default function Contact() {
  return (
     <div className="contact-container">
       <img src="/blur.jpg" alt="Bus" className="blur-image" />
       <div className="contact-card">
       <h2 className="contact-title">
           Contact Us
        </h2>
       <FaEnvelope className="email-icon"/><a href="mailto:contact@evidebus.info" className="contact-email">
          contact@evidebus.info
        </a>
        <p className="contact-tagline">
          Together, we can make every trip more convenient.
        </p>
      </div>
    </div>
  );
}


